import React from "react";
import { BlockMath } from "react-katex";

function getLatexString(dividend, divisor) {
  let latexExpressionTemplate = `\\frac{\\text{\\textit{${dividend}}}}{\\text{\\textit{${divisor}}}}`;
  return latexExpressionTemplate;
}

const de = (
  <div>
    <p>Mit dieser Kennzahl sollen alle direkten und indirekten Kosten ermittelt werden, die einem Unternehmen durch eine Vollzeitstelle entstehen.</p>
    <BlockMath>{getLatexString("Selbstkosten", "Vollzeitstellen")}</BlockMath>
  </div>
);

const fr = (
  <div>
    <p>Cet indicateur mesure l'ensemble des coûts directs et indirects qu'un équivalent temps plein engendre pour une entreprise.</p>
    <BlockMath>{getLatexString("Coûts de revient", "Équivalents temps plein")}</BlockMath>
  </div>
);

const it = (
  <div>
    <p>Questo indicatore serve a determinare tutti i costi diretti e indiretti sostenuti da un'azienda per un posto di lavoro a tempo pieno.</p>
    <BlockMath>{getLatexString("Spese proprie", "N. posti di lavoro a tempo pieno")}</BlockMath>
  </div>
);

const en = (
  <div>
    <p>This key figure is for determining all direct and indirect costs incurred by a business in connection with a full-time position.</p>
    <BlockMath>{getLatexString("Cost price", "Number of full-time positions")}</BlockMath>
  </div>
);

let text = {
  de,
  fr,
  it,
  en,
};

export default text;
